import "core-js/modules/es6.date.now";
import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.array.map";
export default function genDateValue(length) {
  return new Array(length).fill(1).map(function (_, idx) {
    return {
      date: new Date(Date.now() - idx * 3600000),
      // eslint-disable-next-line no-bitwise
      value: Math.max(250, Math.random() * 3000 | 0)
    };
  });
}